window.addEventListener('load', function () {
  const bodyStyles = window.getComputedStyle(document.body);
  const scrollTopOffset = parseInt(bodyStyles.getPropertyValue('--scroll-top-offset'));
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.getAttribute('href') == '#manage-cookies') {
        tarteaucitron.userInterface.openPanel();
      } else {      
        window.scrollTo({
          behavior: 'smooth',
          top: document.querySelector(this.getAttribute('href')).offsetTop - scrollTopOffset,
        });
      }
    });
	});
});